import Image from 'next/image';

import nero_infinity_1 from '../assets/icon/nero_infinity_1.png';
import nero_infinity_2 from '../assets/icon/nero_infinity_2.png';
import nero_infinity_3 from '../assets/icon/nero_infinity_3.png';
import nero_infinity_4 from '../assets/icon/nero_infinity_4.png';

export const deviceArray = [
  {
    text: 'nero infinity 1',
    image: nero_infinity_1,
  },
  {
    text: 'nero infinity 2',
    image: nero_infinity_2,
  },
  {
    text: 'nero infinity 3',
    image: nero_infinity_3,
  },
  {
    text: 'nero infinity 4',
    image: nero_infinity_4,
  }
];

export default function NeroInfinitySlider(text, image) {
  return (
    <div className="w-full h-full grid place-items-center">
      <Image
        className="w-full h-full object-contain rounded-md"
        src={image}
        alt={text}
        sizes="(max-width: 768px) 100vw,
              (max-width: 1200px) 50vw,
              33vw"
      />
    </div>
  );
}

export const NeroInfinitySliderArray = deviceArray.map((nero) => {
  return NeroInfinitySlider(nero.text, nero.image);
});
